import { combineReducers } from '@reduxjs/toolkit';
import { surveysReducer } from './reducers/surveys-reducer';
import { surveyReducer } from './reducers/survey-reducer';
import type { ISurveysModuleState } from './interfaces';

export default combineReducers<ISurveysModuleState>({
  surveysReducer,
  surveyReducer
});